function getGreeting() {
  // Get current time in UTC
  const now = new Date();

  // Convert to IST (UTC +5:30)
  const ISTOffset = 5.5 * 60; // in minutes
  const localOffset = now.getTimezoneOffset(); // in minutes
  const ISTTime = new Date(now.getTime() + (ISTOffset + localOffset) * 60000);

  const hours = ISTTime.getHours();

  if (hours >= 5 && hours < 12) {
    return "Good Morning";
  } else if (hours >= 12 && hours < 17) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
}
export { getGreeting };
